import { render } from "./ListeTypeOrganisation.vue?vue&type=template&id=545f34ff&ts=true"
import script from "./ListeTypeOrganisation.vue?vue&type=script&lang=ts"
export * from "./ListeTypeOrganisation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__